<template>
	<div>
		<div :class="{'background-green' : active}" class="list-border mt-3">
			<div class="padding-16">
				<img class="who-text-margin mr-2" width="14" height="24" src="../../../../assets/images/icons/solid/automation_what.svg"/>
				<label :class="{'automation-group-title-color' : active}" class="automation-group-title ml-3 ">
					WHAT
				</label>
				
				<div v-show="active" class="padding-8-top">
					<condition-group-what
					@updateWHATcondition="updateWHATcondition"
					:edit_view="edit_view"
					:automation_edit_detail="automation_edit_detail"
					:automation_options="automation_event_options"
					@updateWhatAPI="updateWhatAPI"></condition-group-what>
				</div>

			</div>
		</div>

	</div>
</template>
<script>
import conditionGroupWhat from './conditionGroupWhat.vue'
import automationMixin from '../../automationMixin'
export default {
	props:{
		active:{
			active:{
				type: Boolean
			}
		},
		automation_edit_detail:{
			required: false
		},

		edit_view:{
			required: true
		}
	},
	components: {
		conditionGroupWhat

	},
	mixins: [automationMixin],
	data : function(){
		return{
			selection_when:'',
			automation_event_options:[],
			automation_edit_detail_holder:'',
		}
	},
	computed : {
		get_current_actions(){
			return this.automation_edit_detail
		},
		get_current_action_edit(){
			return this.automation_edit_detail_holder
		}
	},
	watch:{
		get_current_actions(val){
			if(val && this.edit_view){
				//console.log(this.automation_edit_detail)
				this.automation_edit_detail_holder = this.automation_edit_detail
				this.automation_edit_detail_holder = val 
			}else{
			//	this.$store.commit('setCurrentAction', {})
			}
		}
		
	},
	created : function(){
		this.getEvents()
	},
	methods : {
		getEvents(){
			var params = {
				filters:{
					organization_id : this.id
				}
			}
			this.$store.dispatch('getAutomationRules_What', params).then((res) => {
				this.automation_event_options = res.data.data
			}).catch((error) => {
				console.log(error);
			});
		},
		updateWhatAPI(actions){
			//this.$store.commit('setCurrentAction', actions)
			this.automation_edit_detail_holder = actions
			this.$emit('updateWhatAPI', actions)
		},
		updateWHATcondition(cond){
			this.$emit('updateWHATcondition', cond)

		}
		
	}
	
}
</script>
<style src="../../automation.css">

</style>


// WEBPACK FOOTER //
// src/components/automation/automationGroups/WHAT/automationWhat.vue